import { BaseTabelaPDF, } from '@monorepo-web/pdf-generator';
import { getLayouts } from './layouts';
export default function TabelaFluxoAtivosPDF(props) {
    const { titulo = 'Movimentações', layout = 'default' } = props;
    const columns = getLayouts()[layout];
    return BaseTabelaPDF(Object.assign(Object.assign({}, props), { titulo,
        columns, tableConfig: {
            columnStyles: Object.fromEntries(// as quarto primeiras colunas da tabela são alinhadas para a esquerda. O restante é alinhado para a direita
            [0, 1, 2, 3].map((col) => [col, { halign: 'left' }])),
        } }));
}
